import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sendRating } from '../actions/knowledgeBaseActions'

class Feedback extends Component {
	constructor() {
		super()
		this.state = {
			sent: false,
			comment: null,
		}
	}
	send(event) {
		event.preventDefault()

		const {
			sendRating,
			item: { nodeId },
		} = this.props
		const { comment } = this.state

		sendRating(nodeId, comment)

		this.setState({
			sent: true,
		})

		return false
	}
	render() {
		const { comment, sent } = this.state

		return sent ? (
			<div>
				<p>Bedankt voor uw feedback</p>
			</div>
		) : (
			<form onSubmit={(event) => this.send(event)} className="form clearfix">
				<h4>Heeft u ideeën over hoe we deze informatie kunnen verbeteren? Laat ze hier achter.</h4>
				<textarea
					className="form-control"
					onChange={(event) => this.setState({ comment: event.target.value })}
				>
					{comment}
				</textarea>
				<button type="submit" className="btn btn-primary">
					verstuur
				</button>
			</form>
		)
	}
}

const mapStateToProps = (state) => ({
	...state,
})
const mapDispatchToProps = (dispatch) => ({
	sendRating: (nodeId, comment) => dispatch(sendRating(nodeId, comment)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Feedback)
